export default __webpack_public_path__ + "static/media/luna.4670683e.jpeg";